import { useState, useEffect } from 'react'

import Api from 'services/api'
import { TableDetail } from 'types/TableDetail'

const useDeviceDetails = (deviceId) => {
  const [deviceMetadataDetails, setDeviceMetadataDetails] = useState<Array<TableDetail> | null>(null)
  const [deviceDetails, setDeviceDetails] = useState<Array<TableDetail> | null>(null)
  const [areDeviceDetailsLoaded, setAreDeviceDetailsLoaded] = useState(false)

  useEffect(() => {
    setDeviceMetadataDetails(null)
    setDeviceDetails(null)
    setAreDeviceDetailsLoaded(false)

    Api.DeviceAggregator.getDeviceDetails(deviceId)
      .then((res) => {
        if (res) {
          const { deviceDetail, deviceMetadataDetail } = res

          setAreDeviceDetailsLoaded(true)
          setDeviceDetails(deviceDetail)
          setDeviceMetadataDetails(deviceMetadataDetail)
        }
      })
      .catch(() => {
        setAreDeviceDetailsLoaded(true)
      })
  }, [deviceId])

  return { deviceDetails, deviceMetadataDetails, areDeviceDetailsLoaded }
}

export default useDeviceDetails
